module.exports = __webpack_public_path__ + "img/terroir-moonlit-3-mobile.4c234d7b.jpg";